import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { apiService } from 'app/services/api.service';
import { endpoints } from 'app/services/endpoints';
import { FlightSearchComponent } from './flight-search/flight-search.component';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FlightBookingDetailComponent } from './flight-booking/flight-booking-detail/flight-booking-detail.component';
import { FlightSeatBookingComponent } from './flight-booking/flight-seat-booking/flight-seat-booking.component';
import { DownloadApplicationComponent } from './download-application/download-application.component';
import { FlightPaymentComponent } from './flight-booking/flight-payment/flight-payment.component';
import { FlightPaymentProcessComponent } from './flight-booking/process-payment/flight-payment-process.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { HotelSearchComponent } from './hotel-search/hotel-search.component';
import { HotelFiltersComponent } from './hotel-filters/hotel-filters.component';
import { ThankYouModalComponent } from './flight-booking/thank-you-modal/thank-you-modal.component';
import { MainLoaderComponent } from './main-loader/main-loader.component';
import { AboutUsComponent } from './cms-pages/about-us/about-us.component';
import { TermsAndConditionsComponent } from './cms-pages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './cms-pages/privacy-policy/privacy-policy.component';
import { FaqComponent } from './cms-pages/faq/faq.component';
import { DatePipe } from '@angular/common';
import { B2cGlobalDataService } from 'app/services/b2cGlobalData.service';

@NgModule({
  declarations: [
    FlightSearchComponent,
    FlightBookingDetailComponent,
    FlightSeatBookingComponent,
    DownloadApplicationComponent,
    FlightPaymentComponent,
    FlightPaymentProcessComponent,
    HotelSearchComponent,
    ThankYouModalComponent,
    MainLoaderComponent,
    AboutUsComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    FaqComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TooltipModule,
    RouterModule,
    NgxUsefulSwiperModule,
    TranslateModule,
    TypeaheadModule.forRoot(),
    ButtonsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    TabsModule.forRoot(),
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgxUsefulSwiperModule,
    FlightSearchComponent,
    FlightSeatBookingComponent,
    FlightBookingDetailComponent,
    DownloadApplicationComponent,
    FlightPaymentComponent,
    TooltipModule,
    HotelSearchComponent,
    ThankYouModalComponent,
    MainLoaderComponent,
    AboutUsComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    FaqComponent
  ],
  providers:[apiService,B2cGlobalDataService,endpoints,DatePipe]
})
export class SharedModule { }
